import React from 'react'
import styled from 'styled-components'

const DivSelector = styled.div`
  margin-top: -0.5rem;
`
// [TODO]: replace with "as" prop on styled-components@4
type SelectorProps = React.ComponentPropsWithoutRef<'div'> & { name: string }
const Selector = ({ name, ...props }: SelectorProps) => {return <DivSelector {...props} />
}

const Button = styled.button<{ selected?: string | null; option?: number }>`
  appearance: none;
  border: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  display: inline;
  cursor: pointer;
  margin-right: 1rem;
  line-height: 2rem;
  color: ${p => (p['aria-pressed'] ? p.theme.primary : p.theme.primaryLight2)};
  font-weight: ${p => (p['aria-pressed'] ? 400 : 400)};
  outline: 0;
`
type LanguageSwitchProps = {
  languages?: string[]
  activeIndex?: number
  setActiveIndex: (arg: number) => void
  name: string
}

type LanguageButtonProps = LanguageSwitchProps & { index: number; children: string; }

const Language = ({ index, activeIndex, setActiveIndex, children }: LanguageButtonProps) => {
  return (
    <Button aria-pressed={index === activeIndex} onClick={() => setActiveIndex(index)}>
      {children}
    </Button>
  )
}

const LanguageSwitch = ({ languages, name, ...props }: LanguageSwitchProps) => {
  if (!languages || !Array.isArray(languages)) return null
  return (
    <Selector name={name}>
      {languages.map((lang, index) => (
        <Language key={lang} index={index} name={name} {...props}>
          {lang.trim().replace(/\W+/, '\xa0' /* no-breaking-space */)}
        </Language>
      ))}
    </Selector>
  )
}

export default LanguageSwitch
